import { Game } from './game/Game';

// Initialize game when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new Game();
});

